// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.deployment_context.DeploymentContext

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { DeploymentEnvironmentData, DeploymentEnvironmentStore } from "./DeploymentEnvironment.generated";
import { DeploymentProcessManagerData, DeploymentProcessManagerStore } from "./DeploymentProcessManager.generated";
import { TerminalSessionData, TerminalSessionStore } from "./TerminalSession.generated";
import { BrowserSessionData, BrowserSessionStore } from "./BrowserSession.generated";

export interface DeploymentContextData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "DeploymentContext";
    envs: Record<string, DeploymentEnvironmentData>;
    processes: DeploymentProcessManagerData;
    terminal_sessions: TerminalSessionData[];
    browser_sessions: BrowserSessionData[];
}

export class DeploymentContextStore {
    readonly _entity_class_name = "DeploymentContext" as const;
    envs: Record<string, DeploymentEnvironmentStore>;
    processes: DeploymentProcessManagerStore;
    terminal_sessions: TerminalSessionStore[];
    browser_sessions: BrowserSessionStore[];
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: DeploymentContextData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.envs = Object.fromEntries(
            Object.entries(data.envs ?? {}).map(([key, val]) => [
                key, wrapEntity(val, transport, [...chainPath, "envs", key]),
            ])
        ) as Record<string, DeploymentEnvironmentStore>;
        this.processes = wrapEntity(data.processes, transport, [...chainPath, "processes"]);
        this.terminal_sessions = wrapEntity(data.terminal_sessions, transport, [...chainPath, "terminal_sessions"]);
        this.browser_sessions = wrapEntity(data.browser_sessions, transport, [...chainPath, "browser_sessions"]);
        makeObservable(this, {
            envs: observable,
            processes: observable,
            terminal_sessions: observable,
            browser_sessions: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async add_env(name: any, engine_type: any, vault_id?: any, engine_settings?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "add_env", [name, engine_type, vault_id, engine_settings], {});
    }

    async remove_env(env_id: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "remove_env", [env_id], {});
    }

    async restore_envs(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "restore_envs", [], {});
    }

    async get_engine_metadata(engine_name: any, engine_settings: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_engine_metadata", [engine_name, engine_settings], {});
    }

    async create_terminal_session(service_name?: any, env_name?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "create_terminal_session", [service_name, env_name], {});
    }

    async destroy_terminal_session(session_id: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "destroy_terminal_session", [session_id], {});
    }

    async create_browser_session(url: any, session_id?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "create_browser_session", [url, session_id], {});
    }

    async destroy_browser_session(session_id: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "destroy_browser_session", [session_id], {});
    }
}

registerEntity("DeploymentContext", DeploymentContextStore);
